<template>
  <div class="zwyDatePicker">
    <span class="rowSpan" @click="selectDate">
      <span class="rowSpan">{{showDate ? (showDate.split("-")[0] + '年' + showDate.split("-")[1] + '月' + showDate.split("-")[2] + '日') : ''}}</span>
      <van-icon v-if="arrow" class="arrow" name="arrow" />
      <i v-else class="corner"></i>
    </span>
    <van-popup position="bottom" v-model="show">
      <van-datetime-picker
        v-model="cdate"
        type="date"
        :title="title ? title : ''"
        :formatter="formatter"
        @confirm="onConfirm"
        @change="onChange"
        @cancel="onCancel"
      />
    </van-popup>
  </div>
</template>

<script>
import Vue from "vue";
import moment from "moment";
import { DatetimePicker, Popup, Icon } from "vant";

Vue.use(DatetimePicker)
  .use(Popup)
  .use(Icon);

export default {
  name: "zwyDatePicker",
  props: ["currentDate", "title", "arrow"],
  components: {},
  data() {
    return {
      show: false,
      showDate: this.currentDate,
      cdate: new Date(this.currentDate),
    };
  },
  mounted() {
   
  },
  methods: {
    formatter(type, value) {
      if (type === "year") {
        return `${value}年`;
      } else if (type === "month") {
        return `${value}月`;
      }else if (type === "date") {
        return `${value}日`;
      }
      return value;
    },
    onConfirm() {
      this.$emit("dateChange", this.showDate);
      this.show = false;
    },
    onCancel() {
      this.cdate = new Date(this.currentDate);
      this.showDate = moment(this.currentDate).format("YYYY-MM-DD");
      this.show = false;
    },
    onChange() {
      this.showDate = moment(this.cdate).format("YYYY-MM-DD");
    },
    selectDate() {
      this.show = true;
    },
  }
};
</script>
<style lang="stylus" scoped>

.zwyDatePicker {
  position relative
  .corner{
    width: 0px;
    height: 0px;
    border: 4px solid #b4bec7;
    border-bottom-color: transparent;
    border-left-color: transparent;
    border-right-color: transparent;
    position: absolute;
    right: -0.12rem;
    top: 0.1rem;
  }
  .dateWrapper {
    text-align: center;
    font-size: 0.16rem;
    padding: 0.14rem 0;
    color: #1fadf6;
  }

  span {
    padding: 0 0.12rem;
  }

  .triangle_border_down {
    width: 0;
    height: 0;
    border-width: 5px 5px 0;
    border-style: solid;
    border-color: #1fadf6 transparent transparent;
    position: relative;
    top: 0.1rem;
    left: 0.08rem;
  }
  .rowSpan{
    padding 0
  }
  .van-icon-arrow{
    margin-left 0.04rem
    position relative
    top 0.02rem
  }
}
</style>